import * as React from 'react';

import {Button} from 'shells/button/button';
import {SaveButton} from 'shells/button/save-button/save-button';
import {Stack} from 'shells/layout/stack/stack';

type Props = {
    onClose: () => void;
    isSaving: boolean;
    handleSave: () => void;
};

export function FooterButtons(props: Props) {
    return (
        <Stack isHorizontal={true} justifyContent='space-between'>
            <Button variant='secondary' onClick={props.onClose} size='big'>
                Cancel
            </Button>
            {/* @ts-expect-error */}
            <SaveButton isSaving={props.isSaving} onClick={props.handleSave} />
        </Stack>
    );
}
